import { render, staticRenderFns } from "./cambioEstado.vue?vue&type=template&id=2ba44876&"
import script from "./cambioEstado.vue?vue&type=script&lang=js&"
export * from "./cambioEstado.vue?vue&type=script&lang=js&"
import style0 from "./cambioEstado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports